var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#19a0f4;}.b{fill:#fff;stroke:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.009 -0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.333 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(-0.324 -0.324)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.907,68.145a.5.5,0,0,0-.711,0L3.173,74.168.858,71.853a.5.5,0,0,0-.711.711l2.671,2.671a.5.5,0,0,0,.711,0l6.379-6.379A.5.5,0,0,0,9.907,68.145Z",
    transform: "translate(6.78 -59.956)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.384db37c.svg";
export { ForwardRef as ReactComponent };